export const AXIOS_ENV_URL = {
  development: window.atob('aHR0cHM6Ly9ib2UtZ2FtZWZsb3cuYnl0ZWRhbmNlLm5ldA=='),
  production: '//',
};

export const BUILD_ENV: any = process.env.NODE_ENV;
export const NODE_ORIGIN =
  window.location.origin === 'http://localhost:9999'
    ? AXIOS_ENV_URL.development
    : window.location.origin;
